(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
class HeroSlider extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.isAnimating = false;
    this.slides = [];
    this.dots = [];
    this.progressBar = null;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));

    const autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
    this.slideCount = parseInt(this.dataset.slideCount, 10) || 1;

    // Progress bar
    this.progressBar = document.createElement('div');
    this.progressBar.className = 'hero-slider__progress';
    this.progressBar.style.setProperty('--autoplay-speed', this.autoplaySpeed + 'ms');
    this.appendChild(this.progressBar);

    // Dot click handlers
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10);
        if (idx !== this.currentIndex && !this.isAnimating) {
          this.goTo(idx);
          if (autoplay) this.restartAutoplay();
        }
      });
    });

    if (autoplay && this.slideCount > 1) {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  goTo(index) {
    if (this.isAnimating || index === this.currentIndex) return;
    this.isAnimating = true;

    // Outgoing slide
    this.slides[this.currentIndex]?.classList.remove('is-active');
    this.dots[this.currentIndex]?.classList.remove('is-active');
    this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');

    this.currentIndex = index;

    // Incoming slide
    this.slides[this.currentIndex]?.classList.add('is-active');
    this.dots[this.currentIndex]?.classList.add('is-active');
    this.dots[this.currentIndex]?.setAttribute('aria-selected', 'true');

    // Video handling: pause all, play active
    this.slides.forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (i === this.currentIndex) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    setTimeout(() => { this.isAnimating = false; }, 750);
  }

  next() {
    const nextIndex = (this.currentIndex + 1) % this.slideCount;
    this.goTo(nextIndex);
  }

  startAutoplay() {
    this.stopAutoplay();
    this.resetProgress();
    this.autoplayTimer = setInterval(() => {
      this.next();
      this.resetProgress();
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  resetProgress() {
    if (!this.progressBar) return;
    this.progressBar.classList.remove('is-animating');
    void this.progressBar.offsetWidth;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.progressBar.classList.add('is-animating');
      });
    });
  }
}

if (!customElements.get('hero-slider')) {
  customElements.define('hero-slider', HeroSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
